import type { Deal } from '../types';

/**
 * Calcola l'importo da visualizzare per un deal:
 * - Base: somma dei deal_services.amount (o discounted_amount se presente)
 * - + variabili confermate NON esenti IVA e NON costi interni
 *
 * Le variabili esenti IVA (is_vat_exempt=true) come le marche da bollo Art.15
 * non vengono incluse nel calcolo.
 */
export function calculateDisplayAmount(deal: Deal): number {
  let total = 0;

  // I campi numeric Postgres arrivano spesso come stringa via supabase-js.
  // Se non si forza Number(), `0 + "5900"` produce la STRINGA "05900" e
  // toLocaleString su stringa non separa le migliaia → bug "€5900,00".
  const toNum = (v: unknown): number => {
    if (v === null || v === undefined || v === '') return 0;
    const n = typeof v === 'number' ? v : Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  // Base: somma degli importi dei servizi (fallback a deal.amount se deal_services assente)
  if (!deal.deal_services) {
    return toNum(deal.amount);
  }
  if (deal.deal_services) {
    deal.deal_services.forEach(service => {
      // discounted_amount ha priorita' su amount se valorizzato (>0)
      const disc = toNum(service.discounted_amount);
      const amt = toNum(service.amount);
      total += disc > 0 ? disc : amt;

      // Aggiungi variabili confermate non esenti IVA
      if (service.deal_variables) {
        service.deal_variables.forEach((variable: any) => {
          // Include solo variabili:
          // - confermate (is_confirmed = true)
          // - NON esenti IVA (is_vat_exempt = false o undefined)
          // - NON costi interni (is_cost = false o undefined)
          if (variable.is_confirmed && !variable.is_vat_exempt && !variable.is_cost) {
            let variableAmount = 0;
            if (variable.type === 'percentage' && variable.base_amount) {
              variableAmount = (toNum(variable.base_amount) * toNum(variable.amount)) / 100;
            } else {
              variableAmount = toNum(variable.amount);
            }
            total += variableAmount;
          }
        });
      }
    });
  }

  return total;
}
